import React, { ReactNode } from 'react'
import Flatpickr from "react-flatpickr";
import { Russian } from "flatpickr/dist/l10n/ru.js"

interface IInput {
    changeHandler: (data: any) => any,
    blurHandler?: (data: any) => any,
    value: string,
    placeholder?: string,
    disabled?: boolean,
    label?: string | ReactNode
    name: string,
    customClassName?: string,
    customLabelClassName?: string,
    customLabel?: React.ComponentType<{}>
    validationError?: boolean,
    validationErrorDescription?: string,
    require?: boolean,
    id?: string,
    appendTo?: HTMLElement|null
}

const Input: React.FC<IInput> = (
    {
        changeHandler,
        placeholder,
        disabled = false,
        label,
        name,
        customClassName,
        customLabelClassName,
        customLabel,
        validationError,
        validationErrorDescription,
        value,
        blurHandler,
        require = true,
        appendTo
    }
) => {

    // @ts-ignore
    return (
        <>
            {customLabel ?
                (
                    <div className="flex">
                        {/*@ts-ignore*/}
                        {customLabel}
                    </div>
                )
                :
                label &&
                (
                    <>
                        <label
                            className={`block text-gray-600 text-left font-medium mb-1 ${customLabelClassName ? customLabelClassName : ""}`}
                            htmlFor={name}
                        >
                            {label}
                            {require && <span className="text-red-500 px-1">*</span>}
                        </label>
                    </>
                )
            }
            <Flatpickr value={value} disabled={disabled} options={{ appendTo: appendTo || undefined, static:true, enableTime: true, time_24hr: true, locale: Russian }} className="form-input w-[150px] py-1 text-[14px] rounded-md" onChange={changeHandler} name={name}/>
            {
                validationErrorDescription && (
                    <div className="text-xs text-left text-red-500">
                        {validationErrorDescription}
                    </div>
                )
            }
        </>
    )
}

export default Input